import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import React, { FC, useState, useEffect } from 'react';

import {
  DayPickerSingleDateController,
  DayPickerSingleDateControllerShape,
} from 'react-dates';
import moment, { Moment } from 'moment';

import { ChevronLeft, ChevronRight } from '@assets/icons';
import { renderEvents } from '@components/views/hotel/detail/components/room-selection/components/AvailableRoomDates/helpers';

import {
  DatePickerWrapper,
  NavNextButton,
  NavPrevButton,
} from '../DatePickerStyle';
import { renderNavButton } from '../renderNavButton';
import { useCalendarEventsDates } from '../useCalendarEventsDates';

type RequiredProps = 'focused' | 'onFocusChange' | 'initialVisibleMonth';

export type DayPickerSingleDateControllerProps = Omit<
  DayPickerSingleDateControllerShape,
  RequiredProps | 'renderMonthText'
> &
  Partial<Pick<DayPickerSingleDateControllerShape, RequiredProps>>;

const SingleDatePicker: FC<DayPickerSingleDateControllerProps> = (props) => {
  const [focused, setFocused] = useState(true);
  const [drawerContentHeight, setDrawerContentHeight] = useState<number | null>(
    null
  );

  const { events } = useCalendarEventsDates();

  const onFocusChange = () => {
    setFocused(true);
  };

  const findDrawerContentHeight = () => {
    if (typeof window !== 'undefined') {
      const el = document.getElementsByClassName('setur-drawer-body')[0];
      return el?.clientHeight;
    }
  };

  useEffect(() => {
    setDrawerContentHeight(findDrawerContentHeight() as number);
  }, [drawerContentHeight]);

  return (
    <DatePickerWrapper contentHeight={drawerContentHeight as number}>
      <DayPickerSingleDateController
        {...props}
        initialVisibleMonth={null}
        focused={focused}
        onFocusChange={onFocusChange}
        renderDayContents={(day) => renderEvents(day, events)}
      />
    </DatePickerWrapper>
  );
};

export const dateRangePickerDefaultProps: DayPickerSingleDateControllerProps = {
  focused: false,
  onFocusChange: () => false,
  date: null,
  onDateChange: () => false,
  isOutsideRange: (day: Moment) => {
    const today = moment().startOf('day');
    return day.isBefore(today);
  },

  renderNavPrevButton: renderNavButton(NavPrevButton, ChevronLeft),
  renderNavNextButton: renderNavButton(NavNextButton, ChevronRight),
  daySize: 33,
  initialVisibleMonth: null,
  verticalBorderSpacing: 3,
  orientation: 'horizontal',
  withPortal: false,
  numberOfMonths: 2,
  keepOpenOnDateSelect: false,
  isRTL: false,
  enableOutsideDays: false,
  hideKeyboardShortcutsPanel: true,
  monthFormat: 'MMMM YYYY',
};

SingleDatePicker.defaultProps = dateRangePickerDefaultProps;
export default SingleDatePicker;
